var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{attrs:{"type":"daterange","align":"right","unlink-panels":"","range-separator":"-","start-placeholder":_vm.startPlaceholder,"end-placeholder":_vm.endPlaceholder,"picker-options":_vm.pickerOptions,"size":"small"},model:{value:(_vm.pickedTime),callback:function ($$v) {_vm.pickedTime=$$v},expression:"pickedTime"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }